import { AfterViewInit, ElementRef } from '@angular/core';
import {Directive, Output, EventEmitter} from '@angular/core';
@Directive({
 selector: '[afterViewInit]'
})
export class AfterViewInitDirective implements AfterViewInit{
    constructor(public elementRef: ElementRef){}
    ngAfterViewInit (): void {
        this.afterViewInit.emit(this);
    }
    @Output('afterViewInit') afterViewInit:EventEmitter<AfterViewInitDirective> = new EventEmitter();
}